/**
 * Created by zhangce on 17/8/10.
 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { LinearProgress } from '../progress';

class ProgressBar extends Component {
  state = {
    value: 0,
  };

  update = value => {
    this.setState({
      value,
    });
  };

  render() {
    const { value } = this.state;
    return <LinearProgress {...this.props} value={value} showInfo={false} />;
  }
}
const defaultProps = {
  className: 'ne-loading-bar',
  duration: 2000,
  strokeWidth: 4,
};
const loadingBar = {
  initial(props = defaultProps, callback) {
    const root = document.body;
    const containerElement = document.createElement('div');
    // 不在DOM中创建节点
    root.appendChild(containerElement);
    let mounted = false;
    function getBar(bar) {
      if (mounted) {
        return;
      }
      mounted = true;
      callback &&
        callback({
          element: bar,
          destroy() {
            ReactDOM.unmountComponentAtNode(containerElement);
            containerElement.parentNode.removeChild(containerElement);
          },
        });
    }
    ReactDOM.render(<ProgressBar {...props} ref={getBar} />, containerElement);
  },

  start() {
    if (this.bar) {
      this.bar.element.update(0);
    } else {
      this.initial(defaultProps, bar => {
        this.bar = bar;
      });
    }
  },
  config(newConfig) {
    Object.assign(defaultProps, newConfig);
    this.destroy();
    this.start();
  },
  destroy() {
    if (this.bar) {
      this.bar.destroy();
      delete this.bar;
    }
  },
  update(value) {
    if (this.bar) {
      this.bar.element.update(value);
    } else {
      this.initial(defaultProps, bar => {
        this.bar = bar;
      });
      this.bar.element.update(value);
    }
  },
  finish() {
    if (this.bar) {
      this.bar.element.update(100);
    } else {
      this.initial(defaultProps, bar => {
        this.bar = bar;
        this.bar.element.update(100);
        setTimeout(() => this.destroy(), 2000);
      });
    }
    // loadingBar.destroy();
  },
};

export default loadingBar;



// WEBPACK FOOTER //
// ./src/loadingBar/LoadingBar.jsx